import React, { useEffect, useState } from 'react';
import ActiveUsers from './activeUsers';
import CourseWiseDistribution from './courseWiseDistribution';
import LicenseDetails from './licenseDetails';
import LicenseSoldUsed from './licenseSoldUsed';
import Attempts from './attempts';
import UserScores from './userScores';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CoursePerformance from './coursePerformance';
import Select from 'react-select';
import apiService from '../../../services/apiService';
import moment from 'moment';


const Dashboard = ({ showDetails = false }) => {

    // const [dateRange, setDateRange] = useState([null, null]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    // const [startDate, endDate] = dateRange;
    const [orgList, setOrgList] = useState([])
    const [selectedOrgId, setSelectedOrgId] = useState('')
    const [selectedId, setSelectedId] = useState()
    const [selectedOrg, setSelectedOrg] = useState()
    const [licenseData, setLicenseData] = useState()
    const [courseDistribution, setCourseDistribution] = useState()
    const [courseP, setCourseP] = useState()
    const [uCourseScore, setUCourseScore] = useState()
    const [userCoursepAttempts, setUserCoursepAttempt] = useState()
    const [orgRevenueCards, setorgRevenueCard] = useState()
    const [activeUsersData, setActiveUsersData] = useState([])
    const [soldUsedLicenses, setSoldUsedLicense] = useState([])


    const handleDateChange = (dates) => {
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
        if (start && end) {
            // let orgData = localStorage.getItem('selectedOrg')
            if (selectedId) {
                fetchLicensesData(selectedId, start, end)
                soldUsedLicense(selectedId, start, end)
                soldCourseDistribution(selectedId, start, end)
                soldCoursePerformance(selectedId, start, end)
                userCoursepScore(selectedId, start, end)
                userCoursepAttempt(selectedId, start, end)
                orgRevenueCard(selectedId, start, end)
                activeUsers(selectedId, start, end)
            } else {
                fetchLicensesData(null, start, end)
                soldUsedLicense(null, start, end)
                soldCourseDistribution(null, start, end)
                soldCoursePerformance(null, start, end)
                userCoursepScore(null, start, end)
                userCoursepAttempt(null, start, end)
                orgRevenueCard(null, start, end)
                activeUsers(null, start, end)
            }
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        getOrgList()
        fetchLicensesData()
        soldUsedLicense()
        soldCourseDistribution()
        soldCoursePerformance()
        userCoursepScore()
        userCoursepAttempt()
        orgRevenueCard()
        activeUsers()
    }, [])

    const getOrgList = () => {
        const token = apiService.getAuthToken()
        apiService.getv1('org-list', token).then((orgList) => {
            console.log("orgList", orgList)
            if (orgList?.data?.length > 0) {
                localStorage.setItem("selectedOrg", JSON.stringify(orgList[0]))
                // setSelectedOrg(orgList.data[0]);
                setOrgList(orgList.data)
            }
        })
    }

    useEffect(() => {
        if (orgList.length > 0) {
            // Set the initial value to the first course in the list
            //setSelectedOrg(orgList[0])
            localStorage.setItem("selectedOrg", JSON.stringify(orgList[0]))
            setSelectedOrgId({
                value: 'all',//orgList[0].org_id,
                label: 'All'//orgList[0].org_name
            });
        }
    }, [orgList]);


    const clearDateRange = () => {
        setStartDate(null);
        setEndDate(null);
        if (selectedId) {
            fetchLicensesData(selectedId)
            soldUsedLicense(selectedId)
            soldCourseDistribution(selectedId)
            soldCoursePerformance(selectedId)
            userCoursepScore(selectedId)
            userCoursepAttempt(selectedId)
            orgRevenueCard(selectedId)
            activeUsers(selectedId)
        } else {
            fetchLicensesData()
            soldUsedLicense()
            soldCourseDistribution()
            soldCoursePerformance()
            userCoursepScore()
            userCoursepAttempt()
            orgRevenueCard()
            activeUsers()
        }
    };


    const fetchLicensesData = (orgId, start, end) => {
        // const token = apiService.getAuthToken()
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`licenses?org_id=${org_id || ''}&startDate=${formattedStartDate || ''}&endDate=${formattedEndDate || ''}`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setLicenseData(response?.data)
            }
        })
    }

    const soldUsedLicense = (orgId, start, end) => {
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`sold-used-licenses?org_id=${org_id || ''}&startDate=${formattedStartDate || ''}&endDate=${formattedEndDate || ''}&courseId=`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setSoldUsedLicense(response?.data)
            }
        })
    }

    const soldCourseDistribution = (orgId, start, end) => {
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`course-distribution?org_id=${org_id || ''}&startDate=${formattedStartDate || ''}&endDate=${formattedEndDate || ''}&courseId=`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setCourseDistribution(response?.data)
            }
        })
    }

    const soldCoursePerformance = (orgId, start, end) => {
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`course-performance?org_id=${org_id || ''}&startDate=${formattedStartDate || ''}&endDate=${formattedEndDate || ''}&courseId=`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setCourseP(response?.data)
            }
        })
    }

    const userCoursepScore = (orgId, start, end) => {
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`user-course-score?org_id=${org_id || ''}&startDate=${formattedStartDate || ''}&endDate=${formattedEndDate || ''}&courseId=`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setUCourseScore(response?.data)
            }
        })
    }

    const userCoursepAttempt = (orgId, start, end) => {
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`course-attempt-performance?org_id=${org_id || ''}&startDate=${formattedStartDate || ''}&endDate=${formattedEndDate || ''}&test_type:end_line`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setUserCoursepAttempt(response?.data)
            }
        })
    }

    const orgRevenueCard = (orgId, start, end) => {
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`org-revenue-card?org_id=${org_id || ''}&startDate=${formattedStartDate || defaultStartDate}&endDate=${formattedEndDate || defaultEndDate}&courseId=`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setorgRevenueCard(response?.data)
            }
        })
    }

    const activeUsers = (orgId, start, end) => {
        let formattedStartDate = start ? moment(start).format('YYYY-MM-DD') : undefined;
        let formattedEndDate = end ? moment(end).format('YYYY-MM-DD') : undefined;
        const org_id = orgId
        const today = moment();
        const oneMonthAgo = moment(today).subtract(30, 'days');
        const defaultStartDate = moment(oneMonthAgo).format('YYYY-MM-DD');
        const defaultEndDate = moment(today).format('YYYY-MM-DD');
        const token = apiService.getAuthToken()
        apiService.getanalytics(`daily-active-users?startDate=${formattedStartDate || defaultStartDate}&endDate=${formattedEndDate || defaultEndDate}`, token).then((response) => {
            console.log("response", response)
            if (response?.data) {
                setActiveUsersData(response?.data)
            }
        })
    }

    const handleOrgSelect = (selectedOptions) => {
        setSelectedOrgId(selectedOptions)
        setSelectedOrg(selectedOptions);
        setSelectedId(selectedOptions.value)
        // localStorage.setItem("selectedOrg", JSON.stringify(selectedOptions))
        if (startDate && endDate) {
            fetchLicensesData(selectedOptions.value, startDate, endDate)
            soldUsedLicense(selectedOptions.value, startDate, endDate)
            soldCourseDistribution(selectedOptions.value, startDate, endDate)
            soldCoursePerformance(selectedOptions.value, startDate, endDate)
            userCoursepScore(selectedOptions.value, startDate, endDate)
            userCoursepAttempt(selectedOptions.value, startDate, endDate)
            orgRevenueCard(selectedOptions.value, startDate, endDate)
            activeUsers(selectedOptions.value, startDate, endDate)
        } else {
            fetchLicensesData(selectedOptions.value)
            soldUsedLicense(selectedOptions.value)
            soldCourseDistribution(selectedOptions.value)
            soldCoursePerformance(selectedOptions.value)
            userCoursepScore(selectedOptions.value)
            userCoursepAttempt(selectedOptions.value)
            orgRevenueCard(selectedOptions.value)
            activeUsers(selectedOptions.value)
        }
    };

    return (
        <div className='page__main'>
            <div className="dashboard jetadmin">
                <h1 className='font-26 fw-bold my-4'>Dashboard</h1>
                <div className="container-fluid my-3">
                    <div className="row banner-box position-relative">
                        <div className="col-md-7 text-white p-5 d-flex flex-column justify-content-center">
                            <h2 className="ms-3">
                                At Inclusional, we help you integrate <br />
                                diversity into business.
                            </h2>
                            <div className="d-flex gap-4 mt-4 ms-3">
                                <div className="d-flex align-items-center">
                                    <img
                                        src="./images/Diversity.svg"
                                        alt="Diversity"
                                        className="icon-img me-2"
                                    />
                                    <span>Diversity</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <img
                                        src="./images/inclusion.svg"
                                        alt="Inclusion"
                                        className="icon-img me-2"
                                    />
                                    <span>Inclusion</span>
                                </div>
                                <div className="d-flex align-items-center">
                                    <img
                                        src="./images/Belonging.svg"
                                        alt="Belonging"
                                        className="icon-img me-2"
                                    />
                                    <span>Belonging</span>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-5 d-flex justify-content-end align-items-start">
                            <img
                                src="./images/Dashboard.png"
                                alt="Thumb and Bulb"
                                className="banner-image img-fluid"
                            />
                        </div>
                    </div>

                </div>
                <div className='d-flex justify-content-between align-items-center mb-4'>
                    <div className='w-25'>
                        <Select
                            id="orgSizeSelect"
                            name="selectedOrgSize"
                            placeholder="Select organisation"
                            value={selectedOrgId}
                            options={orgList?.map((ele) => ({
                                value: ele.org_id,
                                label: ele.org_name
                            }))}
                            onChange={handleOrgSelect}
                        >
                        </Select>
                    </div>

                    <div className='d-flex justify-content-center align-items-start'>
                        <DatePicker
                            selectsRange
                            startDate={startDate}
                            endDate={endDate}
                            onChange={handleDateChange}
                            maxDate={new Date()}
                            placeholderText='Last 30 days'
                            className='p-2 mb-4 me-2'
                        />
                        <button onClick={clearDateRange} className="btn-clear btn btn-md btn-secondary font-16 p-2 ms-2">Clear</button>
                    </div>

                    {/* <DatePicker
                            selectsRange={true}
                            startDate={startDate}
                            endDate={endDate}
                            placeholderText='Select Date'
                            className='p-2 mb-4 ms-2'
                            onChange={(update) => {
                                setDateRange(update);
                            }}
                            withPortal
                        /> */}
                </div>
                <div className='w-100 d-flex justify-content-between mb-4'>
                    <div className='w-65 d-flex'>
                        <div className='me-2 p-3 block bg_red'>
                            <h4 className='d-flex flex-column-reverse justify-content-between mb-3 fw-bold' style={{ color: '#7C0D06' }}>{orgRevenueCards && orgRevenueCards.length ? orgRevenueCards[0]?.new_org : 0}
                                <img
                                    src="./images/Diversity.svg"
                                    alt="Diversity"
                                    className="icon-img mb-3"
                                />
                            </h4>
                            <h6 className='text-white me-4 fw-bold'>New Organization</h6>
                        </div>
                        <div className='mx-2 p-3 block bg_yellow'>
                            <h4 className='d-flex flex-column-reverse justify-content-between mb-3 fw-bold' style={{ color: '#7C0D06' }}>{orgRevenueCards && orgRevenueCards.length ? orgRevenueCards[0]?.active_org : 0}
                                <img
                                    src="./images/primary_contact_icon.svg"
                                    alt="Inclusion"
                                    className="icon-img mb-3"
                                />
                            </h4>
                            <h6 className='text-white me-4 fw-bold'>Active Organization</h6>
                        </div>
                        <div className='mx-2 p-3 block bg_green'>
                            <h4 className='d-flex flex-column-reverse justify-content-between mb-3 fw-bold' style={{ color: '#7C0D06' }}> {orgRevenueCards && orgRevenueCards.length ? Number(orgRevenueCards[0]?.license_sold) : 0}
                                <img
                                    src="./images/license.svg"
                                    alt="License"
                                    className="icon-img mb-3"
                                />
                            </h4>
                            <h6 className='text-white me-4 fw-bold'>Licenses Sold</h6>
                        </div>
                        <div className='mx-2 p-3 block bg_pink'>
                            <h4 className='d-flex flex-column-reverse justify-content-between mb-3 fw-bold' style={{ color: '#7C0D06' }}>{orgRevenueCards && orgRevenueCards.length ? Number(orgRevenueCards[0]?.sales_generated) : 0}
                                <img
                                    src="./images/Belonging.svg"
                                    alt="Belonging"
                                    className="icon-img mb-3"
                                />
                            </h4>
                            <h6 className='text-white me-4 fw-bold'>Sales Generated</h6>
                        </div>
                    </div>
                </div>
                <LicenseDetails showDetails={false} licenseDataFromDasboard={licenseData || {}} selectedOrgId={selectedId} />
                <CourseWiseDistribution showDetails={false} courseDistribution={courseDistribution || {}} selectedOrgId={selectedId} />
                <LicenseSoldUsed showDetails={false} soldUsedLicensesProps={soldUsedLicenses || []} selectedOrgId={selectedId} />
                <CoursePerformance showDetails={false} coursePerformanceProps={courseP || []} selectedOrgId={selectedId} />
                {/*  <UserScores showDetails={false} userScoresProps={uCourseScore||[]} selectedOrgId={ selectedId}/> */}
                <Attempts showDetails={false} attemptsProps={userCoursepAttempts || []} selectedOrgId={selectedId} />
                <ActiveUsers showDetails={false} activeUsersProps={activeUsersData || []} selectedOrgId={selectedId} />
            </div>
        </div>
    )

}

export default Dashboard;